import { useEffect, useState } from 'react';
import Header from 'src/components/demo-day/header/Header';
import cx from '../demo-day/index.module.scss';
import styles from '../demo-day-register/index.module.scss';
import { calendaricon, demoDayHeroBanner, invitationicon, loginlogo, scheduleicon } from 'src/assets/images';
import Stepper from 'src/components/demo-day-register/Stepper/Stepper';
import { Button, Loader, TStep } from 'src/components/common';
import Register from 'src/components/demo-day-register/register/Register';
import { clearDemoDay, clearMyVenture, getDemoDay, getVentureCounters } from 'src/store/venture/venture.slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import SubmitPitchDeck from 'src/components/demo-day-register/submit-pitch-deck/SubmitPitchDeck';
import Calendar from 'src/components/demo-day-register/calendar/Calendar';
import { formatDate } from 'src/utils';
import { calculateDuration, formatSmartDuration } from 'src/utils/calculateDuration/calculateDuration';
import { useNavigate } from 'react-router-dom';
import { convertUTCDateToTime } from 'src/utils/convertUTCDateToTime/convertUTCDateToTime';
const DemoDaySuccess = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch();
    const { paramValue } = useUrlParamValue();

    const ventureVerseId: string = paramValue({ paramName: 'id' }) as string;
    const { demoDay, ventureLoading } = useAppSelector(
        (store) => store.venture
    );
    function handleNavigate() {
        navigate(`/demo-day-detail?id=${ventureVerseId}`, { replace: true })
    }

    useEffect(() => {
        if (ventureVerseId !== 'undefined') {
            dispatch(getDemoDay({ ventureVerseId }))
        } else {
            navigate('/demo-day')
        }
        return () => {
            dispatch(clearDemoDay())
        }
    }, [ventureVerseId]);

    return (
        <div className={cx.demoDay}>
            <Header />
            <div className={cx.demoDayContent}>

                <section className={`${styles.content} ${styles.success}`}>
                    {!ventureLoading && <div className={styles.successContainer}>

                        <div className={styles.left}>
                            <div className={styles.confirmationCard}>
                                <div className={styles.successHeader}>
                                    <span className={styles.icon}>✅</span> <strong>You&apos;re All Set!</strong>
                                </div>
                                <p>Your slot for <strong>Demo Day: Round 1</strong> has been successfully booked.</p>
                                <p>We&apos;ve sent a confirmation email with all your booking details.</p>

                                <div className={styles.bookingDetails}>
                                    <h5>Booking Details</h5>
                                    <p><img src={calendaricon} alt="date" /> <span className={styles.timing}>{formatDate({ dateString: demoDay?.bookingDetails?.date })}</span></p>
                                    <p><img src={scheduleicon} alt="schedule" /> <span className={styles.timing}>{convertUTCDateToTime(demoDay?.bookingDetails?.startTime)} - {convertUTCDateToTime(demoDay?.bookingDetails?.endTime)}</span></p>

                                    {demoDay?.bookingDetails?.startTime && demoDay?.bookingDetails?.endTime ? (
                                        <p><strong>Duration:</strong> {formatSmartDuration(calculateDuration(demoDay?.bookingDetails?.startTime, demoDay?.bookingDetails?.endTime))}</p>
                                    ) : (
                                        <p><strong>Duration:</strong> N/A</p>
                                    )}
                                    <p>
                                        <img src={invitationicon} alt="invitation-icon" />
                                        <strong>
                                            <a
                                                href={demoDay?.bookingDetails?.location?.join_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >Invitation Link</a>
                                        </strong>
                                    </p>
                                </div>

                                <Button variant='primary' size='small' onClick={handleNavigate} style={{ marginTop: '10px', width: 'auto' }}>Go to Detail</Button>
                            </div>
                        </div>

                        <div className={styles.successRight}>
                            <img src={demoDayHeroBanner} alt="Hero visual" className={styles.heroImage} />
                        </div>
                    </div>}
                    {ventureLoading && (
                        <div className="pt-5">
                            <Loader />
                        </div>
                    )}
                </section>
            </div>
        </div>
    );
};

export default DemoDaySuccess;
